import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@getgo/chameleon-web-react-wrapper';

import AdyenCCBuyNow from 'components/adyen-cc-buy-now';
import DefaultDeleteCTAs from 'components/default-delete-ctas';
import useViewPortSize from 'hooks/useViewport';
import { CreditCard } from 'types/payment-method';
import { PAYMENT_METHODS_TYPES } from 'utils/constants';
import { getSupportedCCInfo } from 'utils/credit-card-utils';

import './credit-card-info.css';

interface CreditCardInfoProps {
  ccDetails: CreditCard;
  isActive: boolean;
}

const CreditCardInfo: FC<CreditCardInfoProps> = ({ ccDetails, isActive }): JSX.Element => {
  const intl = useIntl();

  const viewport = useViewPortSize();

  const { type, last4Digits, expirationMonth, expirationYear } = ccDetails;

  const cardInfo = getSupportedCCInfo(type.toUpperCase(), intl);

  const isMobile = viewport.width < 650;

  let cardNumber = `**** **** **** ${last4Digits}`;
  if (isMobile) {
    cardNumber = `**** ${last4Digits}`;
  } else if (cardInfo.ccDigitLength === 15) {
    cardNumber = `**** ****** *${last4Digits}`; // Amex
  }

  return (
    <>
      <section className="card-info">
        <div className="card-info__icon-num">
          {cardInfo.cardIcon}
          <Typography variant="body-small">{cardNumber}</Typography>
        </div>
        <DefaultDeleteCTAs
          isDefault={ccDetails.isDefault}
          isDeletable={ccDetails.isDeletable}
          paymentMethodKey={ccDetails.paymentMethodKey}
          paymentType={PAYMENT_METHODS_TYPES.cc}
          isAdyen={ccDetails.isAdyen}
        />
      </section>
      {(!ccDetails.isAdyen || !isActive) && (
        <Typography
          variant="caption-small"
          color="type-color-secondary"
        >{`${expirationMonth} / ${expirationYear}`}</Typography>
      )}
      {ccDetails.isAdyen && isActive && <AdyenCCBuyNow paymentDetails={ccDetails} />}
    </>
  );
};

export default CreditCardInfo;
